<template>
  <div class="top-left w50 left margin margin_r_hf margin_l_c">
    <div class="styleCard">
      <questions-charts
        v-if="mainView === 'questions'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
      />

      <CampaignsChartsDevice
        v-if="mainView === 'device'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
      />

      <scheduled-calls-charts-block3
        v-if="
          mainView === 'call_again' ||
            (CheckUserPermission([7]) && mainView === 'null')
        "
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

      <as-charts-block3
        v-if="
          mainView === 'assignments' ||
            (CheckUserPermission([1, 2, 3, 4, 5, 12]) && mainView === 'null')
        "
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />

      <reg-hours-chart-block3
        v-if="mainView === 'register'"
        :main-sector="mainView"
        :main-data="multiSelectChartData"
        :tabs="this[mainView]"
        :presets-tabs="this['presets']"
        :stats-tabs="this['statsPresets']"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import QuestionsCharts from "../components/block_3/QuestionsCharts.component";
import scheduledCallsChartsBlock3 from "../components/block_3/ScheduledCallsCharts_Block_3.component";
import AsChartsBlock3 from "../components/block_3/AsCharts_Block_3.component";
import RegHoursChartBlock3 from "../components/block_3/regHoursVolChart_Block_3";

import leads from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ld/leads";
import assignments from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/assignments/assignments";
import call_again from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ca/call_again";
import deposits from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/dp/deposits";
import transfer from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/tr/transfer";
import countries from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/countries/countries";
import sms from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/sms/sms";
import referral from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/referral/referral";
import no_answer from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/no_answer/no_answer";
import presets from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/presets/presets";
import statsPresets from "../../../../../features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/stats/statsTabs";
import CampaignsChartsDevice from "../components/block_3/CampaignsChartsDevice.component";

export default {
  name: "LeftBottomChart.container",
  mixins: [
    UsersPermissionCheck,
    call_again,
    assignments,
    presets,
    statsPresets
  ],
  components: {
    CampaignsChartsDevice,
    QuestionsCharts,
    scheduledCallsChartsBlock3,
    AsChartsBlock3,
    RegHoursChartBlock3
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "loading",
      "chartsViewBlocks",
      "multiSelectChartData"
    ])
  },

  data() {
    return {
      mainView: "call_again",
      blockNumber: 3
    };
  },
  mounted() {},
  created() {},
  watch: {
    chartsViewBlocks() {
      this.mainView = this.chartsViewBlocks[this.blockNumber];
    }
  }
};
</script>

<style scoped>
.styleCard {
  /*height: 270px;*/
  padding-top: 12px;
  padding-right: 12px;
  font-family: Montserrat;
}
.w50 {
  /*width: calc(50%);*/
  width: calc(45%);
}
.left {
  float: left;
}
</style>
